module.exports = __webpack_public_path__ + "images/rich_heading/home_appliance_furniture/bg_eb2b6161e00116040c101f6228aeb86b.png";